const hasRelationship = require("./hasRelationship");

module.exports = function getRowData(entity) {
	let cols = [];
	let widths = [];
	["field_row_column_1", "field_row_column_2", "field_row_column_3"].forEach(
		(field_column_name) => {
			if (hasRelationship(entity.relationships[field_column_name])) {
				const col_data = entity.relationships[field_column_name].data;
				cols.push(col_data);
			}
		}
	);
	const columns_layout = entity.attributes.field_columns_layout;
	if (cols.length > 1) {
		if (columns_layout === "wider_left") {
			widths = cols.length === 2 ? [8, 4] : [6, 3, 3];
		} else if (columns_layout === "wider_right") {
			widths = cols.length === 2 ? [4, 8] : [3, 3, 6];
		} else {
			const default_col_w = cols.length > 0 ? Math.floor(12 / cols.length) : 12;
			widths = [default_col_w, default_col_w, default_col_w];
		}
	} else {
		widths = [12];
	}
	// TODO: add field to support predefined layouts for different column widths at node--row like: [4, 4, 4] [4,8] [8, 4] [6, 6] [6, 3, 3] [3, 9] [9, 3]
	return { cols, widths };
};
